<template>
  <div class="bc-white padding-20 br-4">
    <div class="display-flex jc-space-between ai-flex-start">
      <el-form :inline="true" size="small" v-model="searchForm">
        <el-form-item label="">
          <el-input
            placeholder="搜索"
            suffix-icon="el-icon-search"
            clearable
            v-model="searchForm.fuzzyName"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" icon="el-icon-search" @click="getTableData">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
<!--      <div class="display-flex">-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          icon="el-icon-plus"-->
<!--          size="small"-->
<!--          @click="add">-->
<!--          新增角色-->
<!--        </el-button>-->
<!--        <el-button-->
<!--          type="danger"-->
<!--          icon="el-icon-delete"-->
<!--          size="small"-->
<!--          @click="delRow(selection)">-->
<!--          批量删除-->
<!--        </el-button>-->
<!--      </div>-->
    </div>
    <el-table
      @selection-change="(val) => {selection = val}"
      border
      :data="tableData">
      <el-table-column
        align="center"
        fixed
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="角色名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="code"
        label="角色Code">
      </el-table-column>
      <el-table-column
        align="center"
        width="200px"
        label="操作">
        <template slot-scope="scope">
          <el-button @click="setting(scope.row)" type="text">权限设置</el-button>
<!--          <el-button @click="edit(scope.row)" type="text">编辑</el-button>-->
<!--          <el-button-->
<!--            @click="delRow([scope.row])"-->
<!--            type="text"-->
<!--            class="color-danger">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="display-flex fd-row-reverse mt-20">
      <!-- 表格数据的分页的功能 -->
      <el-pagination
        hide-on-single-page
        @current-change="(val) => {searchForm.page = val}"
        :current-page="searchForm.page"
        :page-size="searchForm.limit"
        background
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-drawer
      size="400px"
      :title="drawer.title"
      :visible.sync="drawer.show">
      <div class="padding-20 pl-10">
        <el-form
          :model="drawer.form"
          ref="ruleForm"
          label-width="100px">
          <el-form-item
            label="角色名称："
            prop="name"
            :rules="{required: true, message: '请输入角色名称', trigger: 'blur'}">
            <el-input placeholder="请输入角色名称" v-model="drawer.form.name"></el-input>
          </el-form-item>
          <el-form-item
            label="角色code："
            prop="code"
            :rules="{required: true, message: '请输入角色code', trigger: 'blur'}">
            <el-input placeholder="请输入角色code" v-model="drawer.form.code"></el-input>
          </el-form-item>
          <el-form-item label="显示排序：" prop="sort" :rules="{required: true, message: '请输入排序', trigger: 'blur'}">
            <el-input-number v-model="drawer.form.sort" controls-position="right" :min="1"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
            <el-button @click="drawer.show = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      size="400px"
      :title="authDrawer.title"
      :visible.sync="authDrawer.show">
      <div class="padding-20 scrollbar-y" style="height: calc(100vh - 100px)">
        <el-scrollbar>
          <el-tree
            default-expand-all
            ref="menuTree"
            :data="menuList"
            show-checkbox
            node-key="id"
            :props="defaultProps">
          </el-tree>
        </el-scrollbar>
        <div class="display-flex fd-row-reverse">
          <div>
            <el-button size="small" type="primary" @click="submitAuth">确认</el-button>
            <el-button size="small" @click="authDrawer.show = false">取消</el-button>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'RoleManage', // 角色管理
  components: {},
  data () {
    return {
      selection: [],
      searchForm: {
        fuzzyName: '',
        page: 1,
        limit: 10
      },
      tableData: [],
      total: 0,
      drawer: {
        show: false,
        title: '',
        form: {
          name: '',
          code: ''
        }
      },
      id: null,
      authDrawer: {
        show: false,
        title: '权限设置',
        data: []
      },
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      menuList: [],
      authId: ''
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (newVal.page !== 1 && newVal.page === oldVal.page) {
          this.searchForm.page = 1;
        } else {
          this.getTableData()
        }
      },
      deep: true
    }
  },
  computed: {
    /**
     * 监听复杂数据类型的变换
     */
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchForm))
    }
  },
  methods: {
    resetSearch () {
      this.searchForm.fuzzyName = ''
      this.searchForm.page = 1
      this.getTableData()
    },
    /**
     * 获取菜单列表
     */
    getMenuList () {
      return new Promise((resolve, reject) => {
        this.$api.menu.getMenuList().then(res => {
          this.menuList = res.map(item => {
            return {
              ...item,
              disabled: !item.children,
              children: item.children ? item.children.map(_item => {
                return {
                  ..._item,
                  disabled: !_item.children
                }
              }) : null
            }
          })
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    setting (row) {
      this.authId = row.id
      this.$api.role.getRoleAuth({ roleId: row.id }).then(res => {
        this.authDrawer.show = true
        this.$nextTick(() => {
          this.$refs.menuTree.setCheckedKeys(res)
        })
      })
    },
    submitAuth () {
      const btnIds = this.$refs.menuTree.getCheckedNodes(false, true).filter(item => item.type === 2).map(_item => _item.id)
      if (btnIds.length) {
        const data = {
          menuIdList: btnIds,
          roleId: this.authId
        }
        this.$api.role.setRoleAuth(data).then(res => {
          this.authDrawer.show = false
          this.$message.success('设置成功')
        })
      } else {
        this.$message.warning('至少添加一个最下级菜单')
      }
    },
    add () {
      this.id = null
      this.drawer = {
        show: true,
        title: '新增角色',
        form: {
          name: '',
          code: '',
          sort: 1
        }
      }
    },
    edit (row) {
      this.id = row.id
      this.drawer = {
        show: true,
        title: '编辑角色',
        form: {
          name: row.name,
          code: row.code,
          sort: row.sort
        }
      }
    },
    /**
     * 提交表单
     * @param formName
     */
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = JSON.parse(JSON.stringify(this.drawer.form))
          if (this.id) {
            data.id = this.id
            this.$api.role.editRole(data).then(res => {
              this.drawer.show = false
              this.$message.success('编辑成功')
              this.getTableData()
            })
          } else {
            this.$api.role.addRole(data).then(res => {
              this.drawer.show = false
              this.$message.success('添加成功')
              this.searchForm.page = 1
              this.getTableData()
            })
          }
        }
      });
    },
    /**
     * 删除
     * @param data
     */
    delRow (data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.role.delRole(data.map(item => item.id)).then(res => {
          this.$message.success('删除成功')
          this.searchForm.page = 1
          this.getTableData()
        })
      }).catch(() => {});
    },
    getTableData: _.debounce(function () {
      const data = {
        pageNum: this.searchForm.page,
        pageSize: this.searchForm.limit,
        fuzzy: this.searchForm.fuzzyName
      }
      this.$api.role.getRoleList(data).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }, 500)
  },
  created () {

  },
  mounted () {
    this.getTableData()
    this.getMenuList()
  }
}
</script>

<style lang="scss" scoped>

</style>
